import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MyCommissionsDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-my-commissions-dialog',
  templateUrl: './my-commissions-dialog.component.html',
  styleUrls: ['./my-commissions-dialog.component.scss']
})
export class MyCommissionsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MyCommissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MyCommissionsDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
  
}
